import '../admin-dashboard.css';
import { handleError, handleSuccess } from '../../../utils';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import http from '../../../core/service/http';
import "./generate-token.css";
import DataTable from 'datatables.net-react';
import DT from 'datatables.net-bs5';
import moment from 'moment';
DataTable.use(DT);


export const useGenerateTokenHook = () => {
    const auth = useSelector((state) => state?.appStore?.auth);
    const [tokens, setGeneratedToken] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [recordCount, setRecordCount] = useState(25);
    const [isLoading, setLoading] = useState(false);

    const [count, setCount] = useState("");

    const getTokens = async (prevCount) => {
        const response = await http.get("/v1/tokens/");
        const data = response.data
            .sort(
                (a, b) => b.id - a.id
            ).map(
                (token, index) => ({
                    id: index + 1,
                    date: moment(token.dated).utc().format(),
                    status: "ACTIVE",
                    memberid: token.memberid,
                    token: `WJCW CF-${token.token}`,
                    fee: "free"
                })
            );
        setGeneratedToken(data.splice(0, prevCount));
        setLoading(false);
    };
    const handleSubmit = async () => {
        setLoading(true);
        try {
            const response = await http.post("/v1/tokens/generate-token", {
                sponsorId: auth.user[0].member_id,
                count,
            });
            if (response) {
                handleSuccess(`${count} token(s) have been generated succesfully!`);
                getTokens(count);
                setCount("");
            }

        } catch (error) {
            if (error.response) {
                handleError(error.response.data.message || "Login failed");
            } else {
                handleError("Network error. Please try again later.");
            }
            setLoading(false);
        }
    };

    const filterHandler = (data) => {
        if (searchTerm == '') {
            return true;
        }
        return (data.token.toLowerCase().indexOf(searchTerm.toLowerCase()) > -1 ||
            data.date.toLowerCase().indexOf(searchTerm.toLowerCase()) > -1 ||
            data.fee.toLowerCase().indexOf(searchTerm.toLowerCase()) > -1 ||
            data.no.toString().indexOf(searchTerm.toLowerCase()) > -1)
    }

    return{
        auth,
        tokens,
        setGeneratedToken,
        searchTerm,
        setSearchTerm,
        count,
        setCount,
        recordCount,
        setRecordCount,
        isLoading,
        getTokens,
        handleSubmit,
        filterHandler
    };
}